export default "__VITE_ASSET__CcbWdT9L__"